import { define } from 'wicked-elements'

define('[data-component~="read-more"]', {
  init() {
    this.state = false
    this.$button = this.element.querySelector('button')
    this.handleClick = this.handleClick.bind(this)
  },
  connected() {
    this.$button.addEventListener('click', this.handleClick)
  },
  disconnected() {
    this.$button.removeEventListener('click', this.handleClick)
  },
  handleClick() {
    if (!this.state) {
      this.$button.innerHTML = 'Read Less'
      this.element.setAttribute('aria-expanded', 'true')
      this.state = true
    } else {
      this.$button.innerHTML = 'Read More'
      this.element.setAttribute('aria-expanded', 'false')
      this.state = false
    }
  },
})
